import * as CONSTANTS from '../constants/constants';
import injectDurations from '../utils/injectdurations';

export const uploadCourse = courseInfo => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const courseData = {
    title: courseInfo.title,
    slug: courseInfo.title.toLowerCase().replace(/[' '|&|,|(|)|&|@|!|%|^|+|=]/gi,"-"),
    subTitle: courseInfo.subTitle,
    description: courseInfo.description,
    tags: courseInfo.tags,
    image: courseInfo.image,
    requirements: courseInfo.requirements,
    youWillLearn: courseInfo.youWillLearn,
    created: Date.now(),
    video:courseInfo.courseVideo,
    userName: courseInfo.userName,
    asDraft: courseInfo.asDraft,
    isNewCourse: courseInfo.isNewCourse
  };

  firestore
    .collection(CONSTANTS.COURSES)
    .add(courseData)
    .then((docRef) => {
      dispatch({ type: CONSTANTS.UPLOAD_COURSE_SUCCESS, docRef });
      dispatch({ type: CONSTANTS.UPLOAD_COURSE_VIDEO_SUCCESS, docRef });
      dispatch({ type: CONSTANTS.RESET_MSGS });
    });
};

export const uploadSection = (sections, courseId) => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING });
  injectDurations(sections,()=>{
    const firebase = getFirebase();
    const firestore = getFirestore();
    const fscourseRef = firestore.collection(CONSTANTS.COURSES).doc(courseId);
    const sectionRef = fscourseRef.collection('sections');
    var totalDuration = 0;
    var lessons =0;
    sections.map((section, index) =>
      {
        console.log(section.duration)
        sectionRef
        .add({ title: section.title,duration:section.duration,position:section.position })
        .then((docRef) => {
          const sectionId = docRef.id;
          const lecturesRef = sectionRef.doc(sectionId).collection('lectures');
          section.lectures.map((lecture, lectureIndex) =>
            lecturesRef.add({ title: lecture.title ,duration:lecture.duration,position:lecture.position,video:lecture.video,files:lecture.files})
            .then((lectRef) => {
              dispatch({ type: CONSTANTS.UPLOAD_VIDEO_PROGRESS, progress:100 });
              dispatch({
                type: CONSTANTS.UPLOAD_COURSE_VIDEO_SUCCESS,
                sectionId})
              dispatch({ type: CONSTANTS.RESET_MSGS });

            })
            
          );
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log('error', e);
        })
        totalDuration += section.duration;
         lessons += section.lessons
      }
    );
    fscourseRef.update({duration:totalDuration,lessons}).then(()=>console.log("Total duration updated",lessons))
    dispatch({ type: CONSTANTS.RESET_MSGS });
    setTimeout(() => {
      window.location.reload()
    }, 3000);
  })
 
  
};


export const editCourse = courseInfo => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  console.log(courseInfo)
  dispatch({ type: CONSTANTS.SET_LOADING });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const path = CONSTANTS.COURSES + '/'+courseInfo.id
  const id = courseInfo.id
  const courseData = {
    title: courseInfo.title,
    subTitle: courseInfo.subTitle,
    slug: courseInfo.title.toLowerCase().replace(/[' '|&|,|(|)|&|@|!|%|^|+|=]/gi,"-"),
    description: courseInfo.description,
    tags: courseInfo.tags,
    image: courseInfo.image,
    lessons: courseInfo.lessons,
    userName: courseInfo.userName,
    duration: courseInfo.duration,
    video:courseInfo.courseVideo,
    requirements: courseInfo.requirements,
    youWillLearn: courseInfo.youWillLearn,
    isNewCourse: courseInfo.isNewCourse,
    asDraft: courseInfo.asDraft,
    created: courseInfo.created
  };
  // var newVideo = false;
  // const { courseVideo } = courseInfo;
  // try {
  //   var url = new URL(courseVideo)
  //   if(url.origin ==="null") newVideo =true;
  //   else courseData.video = courseVideo
  // } catch (error) {
  //   newVideo =true;
  // }

  firestore
    .collection(CONSTANTS.COURSES)
    .doc(id)
    .set(courseData)
    .then(() => {
      var docRef={path,id}
      dispatch({ type: CONSTANTS.UPLOAD_COURSE_SUCCESS, docRef });
      dispatch({ type: CONSTANTS.RESET_MSGS });
        dispatch({ type: CONSTANTS.UPLOAD_COURSE_VIDEO_SUCCESS });
        dispatch({ type: CONSTANTS.RESET_MSGS });
    }).catch((err)=>{console.log(err)});
};

export const editSection = (sections, courseId,removedLect =[],removedSect=[]) => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING });

  injectDurations(sections,()=>{
  const firebase = getFirebase();
  const firestore = getFirestore();
  const fscourseRef = firestore.collection(CONSTANTS.COURSES).doc(courseId);
  const sectionRef = fscourseRef.collection('sections');
  const storageRef = firebase.storage().ref()
  var totalDuration = 0; var lessons=0;
  removedSect.map((section,index)=>{
    sectionRef.doc(section.id).delete().then(function() {
      console.log("Document successfully deleted!");
    }).catch(function(error) {
        console.error("Error removing document: ", error);
    });
  })
  removedLect.map((lect,index)=>{
    sectionRef.doc(lect.sectionId+'/lectures/'+lect.id).delete().then(function() {
      console.log("Document successfully deleted!");
    }).catch(function(error) {
        console.error("Error removing document: ", error);
    });
  })
  sections.map((section, index) =>
   {
      var docRef = 
      { path:sectionRef + '/'+section.id,
        id:section.id}
      sectionRef
      .doc(docRef.id)
      .set({ title: section.title,duration:section.duration,position:section.position })
      .then(() => {
        const sectionId = docRef.id;

        const lecturesRef = sectionRef.doc(sectionId).collection('lectures');
        section.lectures.map((lecture, lectureIndex) =>
          {
            var lectRef = 
            { path:sectionRef + '/'+section.id + '/lectures/' + lecture.id,
              id:lecture.id}
            const lectureId = lectRef.id;
            const lecRef = lectRef.path;
            const { video } = lecture;
              var params ={ title:lecture.title,video,duration:lecture.duration,position:lecture.position,
              files:lecture.files}
            lecturesRef.doc(lecture.id).set(params).then(() => {
              dispatch({
                type: CONSTANTS.UPLOAD_COURSE_VIDEO_SUCCESS,
                sectionId
              });
              dispatch({ type: CONSTANTS.RESET_MSGS });
            
          })
        }
        );

        
      })
      // .catch((e) => {
      //   // eslint-disable-next-line no-console
      //   console.log('error', e);
      // })
      totalDuration+=section.duration;
      lessons +=section.lessons;
    }
   
  );
  fscourseRef.update({duration:totalDuration,lessons }).then(()=>console.log("Total duration updated",lessons))
  })
  
};

export const deleteCourse = (courseId) =>(
  dispatch,
  getState, 
  {getFirebase, getFirestore}) => {
  const firebase = getFirebase();
  const firestore = getFirestore();

  dispatch({ type: CONSTANTS.SET_LOADING });


  const courseRef = firestore.collection(CONSTANTS.COURSES);
  const sectionRef = courseRef.doc(courseId).collection('sections');

  var sections = []

  sectionRef.get().then((querySnapshot) => {
    querySnapshot.forEach((section) => {
      sections.push({ id: section.id })
    });
    sections.map((section) => {
      const lectureRef = sectionRef.doc(section.id).collection('lectures');
      lectureRef.get().then((lectures) => {
        // var lecturesHolder = []
        lectures.forEach((lecture) => {
        var path = `courses/${courseId}/sections/${section.id}/lectures/${lecture.id}/video`
        console.log(path)
        
        var storage = firebase.storage();
        var storageRef = storage.ref();
        var lecVid = storageRef.child(path)

        lecVid.delete().then(() => {
          console.log('lec video deleted')
        }).catch((err) => {
          console.log('error', err)
        })
        });
      }); 
    });
  })
  .catch((err) => {
    console.log('error', err);
  });

  console.log('deleteing promo vid...')
  var storage = firebase.storage();
  var storageRef = storage.ref();
  var promoVid = storageRef.child(`courses/${courseId}/video`)
  promoVid.delete().then(() => {
    console.log('promo video deleted')
  }).catch((err) => {
    console.log('error', err)
  })
  
  firestore.collection("courses").doc(courseId).delete()
    .then(()=>{
      console.log('final deleting...')
      dispatch({ type: CONSTANTS.DELETE_COURSE_SUCCESS  })
      dispatch({ type: CONSTANTS.DELETE_COURSE_RESET_MSGS })
  })
  .catch((err)=> {
    console.log('error', err)
  })
}

export const postLastView =  ({userId,courseId,lectureId,currentTime}) => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firebase = getFirebase();
  const firestore = getFirestore();
  const fsUserRef = firestore.collection("users").doc(userId);
  const lastViewedRef = fsUserRef.collection('lastViewed');
  const fsCourseRef = firestore.collection(CONSTANTS.COURSES)
  try {
      lastViewedRef.doc("lastview").set({
        courseId,
        lectureId,
        currentTime
      })
    } catch (error) {
      console.log(error)
    }
}